import EventBus from '@/vue/events/event-bus'
import moment from 'moment'
import accounting from 'accounting'
import {validateSpecialRBTimer} from '@/js/common/rb-timer'

import {
  mapGetters,
} from 'vuex'

export default {
  computed: {
    ...mapGetters([
      'betLang',
      'sportTableLang',
      'sportAllBetLang',
      'account',
      'highlightedCell',
      'parlaySelected',
      'showFavEvents',
    ]),
  },
  data() {
    return {
      allDate: '99',
      todayDate: '0',
      teamA: 'oddsa',
      teamB: 'oddsb',
      teamHome: 'h',
      teamAway: 'a',
      teamDraw: 'd',
      ftPlyType: '1',
      firstHtPlyType: '2',
      setHandicapPlyType: '3',
      pointHdpPlyType: '4',
      iotPlyType: '5',
      gameHdpPlyType: '6',
      firstSetPlyType: '7',
      secondSetPlyType: '8',
      thirdSetPlyType: '9',
      fourthSetPlyType: '10',
      fifthSetPlyType: '11',
      sixthSetPlyType: '12',
      game1PlyType: '14',
      game2PlyType: '15',
      game3PlyType: '16',
      game4PlyType: '17',
      game5PlyType: '18',
      SecondHtPlyType: '19',
      first5InningsPlayType: '13',
      first3InningsPlayType: '20',
      firstInningsPlayType: '21',
      secondInningsPlayType: '22',
      thirdInningsPlayType: '23',
      fourthInningsPlayType: '24',
      fifthInningsPlayType: '25',
      sixthInningsPlayType: '26',
      seventhInningsPlayType: '27',
      eightthInningsPlayType: '28',
      nineInningsPlayType: '29',
      OTPlayType: '30',
      hdpBetType: '1',
      ouBetType: '2',
      oeBetType: '3',
      onex2BetType: '4',
      tgBetType: '5',
      htftBetType: '6',
      csBetType: '7',
      rhdpBetType: '8',
      rouBetType: '9',
      roeBetType: '10',
      ronex2BetType: '11',
      mlBetType: '12',
      rmlBetType: '13',
      otrBetType: '14',
      mulpBetType: '15',
      rcsBetType: '16',
      rhtftBetType: '17',
      rtgBetType: '18',
      dbchBetType: '19',
      rdbchBetType: '20',
      parlayBetType: '5',
      rbettype : ['8','9','10','11','13','16','17','18','20','27','29','31','33','35','37','39','41','43','45','47','49','51','55','56','58','61','64','66','69','71','73','78','79','81','83'],
      oddTypeBettype : ['1', '2', '3', '8', '9' ,'10' ,'46' ,'47' ,'48' ,'49','80','81','82','83'],
      osCommon: ['1', '2', '3','4','5','6','7','8','9','10','11','12','13','14','15','16','17','18','19','20','21','22','23','24','25','26','27','28','29','30'],
      portBettypeList: window.sportBettypeList,
      h1x2BetType: '21',
      wdBetType: '25',
      rh1x2BetType: '27',
      hmgBetType: '28',
      rhmgBetType: '29',
      hmg1x2BetType: '30',
      rhmg1x2BetType: '31',
      bttsBetType: '32',
      rbttsBetType: '33',
      cshBetType: '34',
      rcshBetType: '35',
      twnBetType: '36',
      rtwnBetType: '37',
      twfbBetType: '38',
      rtwfbBetType: '39',
      twehBetType: '40',
      rtwehBetType: '41',
      twbhBetType: '42',
      rtwbhBetType: '43',
      tsbhBetType: '44',
      rtsbhBetType: '45',
      htgBetType: '46',
      rhtgBetType: '47',
      atgBetType: '48',
      ratgBetType: '49',
      wmBetType: '50',
      rwmBetType: '51',
      flgBetType: '52',
      hldsBetType: '53',
      aldsBetType: '54',
      rhldsBetType: '55',
      raldsBetType: '56',
      moreRBBetTab: ['16','66','70'], 
      moreBetTab: ['7','65','71','74'], 
      subMatchHeight: 70,
      commonMatchHeight: 105,
      moreBetHeight: 32,
      betComboMax: window.betComboMax,
      allowComboBet: window.allowComboBet,
      allBetComboAmount: '',
      rbBetTypeList: ['8','9','10','11','13','16','17','18','20','27','29','31','33','35','37','39','41','43','45','47','49','51','55','56','58','61','64','66','69','71','73', '78','79','81','83'],
      pendingTimerId: null,
      wgSuccess: ['0', '2'], //confirm, rbconfirm
      wgNotsuccessreject: ['0', '-1', '2'],
      wgSts: ['0', '1', '2'],
      keyboardAllow: {
        min: true,
        med: true,
        big: true,
        big2: true,
        big3: true,
      },
      nogBetType: '57',
      rnogBetType: '58',
      ouoeBetType: '59',
      oubttsBetType: '60',
      roubttsBetType: '61',
      ouftsBetType: '62',
      onex2ouBetType: '63',
      ronex2ouBetType: '64',
      onex2bttsBetType: '65',
      ronex2bttsBetType: '66',
      onex2ftsBetType: '67',
      dbchouBetType: '68',
      rdbchouBetType: '69',
      dbchbttsBetType: '70',
      rdbchbttsBetType: '71',
      dbchftsBetType: '72',
      rouoeBetType: '73',
      edgBetType: '74',
      exiBetType: '76',
      wmrBetType: '77',
      rwmrBetType: '78',
      rexiBetType: '79',
      htrBetType: '80',
      rhtrBetType: '81',
      atrBetType: '82',
      ratrBetType: '83',
    }
  },
  methods: {
    setbetComboKeyboard(key){
      //validate amount cannot exceed current CL
      if(parseInt(this.$store.getters.account.currCL) < parseInt(this.$store.getters.betComboAmount[key].value.replace(",", ""))){
        var xarr = {
          index: key,
          amount: accounting.toFixed(this.$store.getters.account.currCL, 0),
          clear: false
        }
        this.betComboAmount = xarr
      }

      if(this.betFormList.length==1 && this.$store.getters.account.rememberStake){
        var a = parseInt(this.$store.getters.betComboAmount[0].value.replace(",", ""))
        this.usualStakeAmount = a
      }

      var remainingBal = this.$store.getters.account.currCL - parseInt(this.$store.getters.betComboAmount[key].value.replace(",", ""))
      this.setKeyboardSettings(key, remainingBal)
    },
    setKeyboardSettings(key, remainingBal){
      var betAmtOpt = this.$store.getters.betting.betAmountOption
      var karr = { index: key, settings:{min: true, med: true, big: true, big2: true, big3: true} }
      var arr = (key=='-1') ? this.keyboardAllow : karr.settings

      this.$set(arr, 'big3', (remainingBal < betAmtOpt.big3) ? false : true)
      this.$set(arr, 'big2', (remainingBal < betAmtOpt.big2) ? false : true)
      this.$set(arr, 'big', (remainingBal < betAmtOpt.big) ? false : true)
      this.$set(arr, 'med', (remainingBal < betAmtOpt.med) ? false : true)
      this.$set(arr, 'min', (remainingBal < betAmtOpt.min) ? false : true)

      if(this.$store.getters.isBetCombo){
        this.betComboKeyboardAllow = karr
      }
    },
    setALLbetComboAmount(){
      let VUE = this
      var fixedAccountingNumber = accounting.toFixed(VUE.allBetComboAmount, 0);
      var res = VUE.allBetComboAmount == 0 ? "" : this.commasAmount(fixedAccountingNumber);

      $.each(VUE.betFormList, function(id, data){
        var arr = {
          index: id,
          amount: accounting.toFixed(VUE.allBetComboAmount, 0),
          clear: false
        }
        VUE.betComboAmount = arr

        var remainingBal = VUE.$store.getters.account.currCL - parseInt(VUE.$store.getters.betComboAmount[id].value.replace(",", ""))
        VUE.setKeyboardSettings(id, remainingBal)
      });

      VUE.allBetComboAmount = res
      //betcombo all share same data property with single wager
      var remainingBalALL = this.$store.getters.account.currCL - parseInt(res.replace(",", ""))
      this.setKeyboardSettings('-1', remainingBalALL)
    },
    setbetComboAmount(comboAmount, key) {
      var arr = {
        index: key,
        amount: accounting.toFixed(comboAmount[key], 0)
      }

    },
    clearALLbetComboAmount(){
      let VUE = this
      VUE.allBetComboAmount = ''
    },
    checkAllowKeyboard(data, keyAllow, key, obj){
      var r = false
      var errCodeAllowKeyboard = ['4003-N', '4010-N'] //, 'N-4018-N'
      
      if(this.$store.getters.isBetCombo){
        if(key!='all' && this.$store.getters.betComboAmount[key].value!='' && (!_.isUndefined(data.error) || !this.$store.getters.betComboKeyboardAllow[key][obj])){
          if(!_.isUndefined(data.error) && !_.isUndefined(data.error.code) && errCodeAllowKeyboard.includes(data.error.code)){
            r = false
          } else {
            r = true
          }
        } else if (key=='all' && !keyAllow){
          r = true
        }
        
      } else if (!this.$store.getters.isBetCombo && !keyAllow){
        r = true
      }
      return r
    },
    betPossiblePayout(key=null){
      var oddValue = ''
      var amount = 0;
      
      if(key!=null && this.$store.getters.betComboAmount[key] && this.$store.getters.betComboAmount.length!=0) {
        var betOdd = parseFloat(this.$store.getters.betForm[key].odd);
        var amt = this.$store.getters.betComboAmount[key].value
        // var amt = this.$store.getters.betComboAmount[key].value.replace(",","")
        oddValue =
          (betOdd < 0 && (this.$store.getters.account.oddsType=='my' || this.$store.getters.account.oddsType=='in'))
            ? 1
            : this.validateOddBetType(
                this.$store.getters.betForm[key].betType,
                this.$store.getters.betForm[key].odd
              );
        amount += Number(amt) * oddValue;
      } else {
        var amt = 0
        // Sum possible payout
        if(this.$store.getters.betComboAmount.length!=0) {
          for (let index=0; index < this.betFormList.length; index++) {
            const betOdd = this.betFormList[index].odd;
            if(this.$store.getters.betComboAmount[index]){
              amt = this.$store.getters.betComboAmount[index].value.replace(",","")
            }
            
            oddValue =
            (betOdd < 0 && (this.$store.getters.account.oddsType=='my' || this.$store.getters.account.oddsType=='in'))
              ? 1
              : this.validateOddBetType(
                  this.$store.getters.betForm[index].betType,
                  this.$store.getters.betForm[index].odd
                );
            amount += Number(amt) * oddValue;
          }
        }
      }
      return amount;
    },
    betFormHeight(){
      let bb = 0
      
      if(this.$store.getters.selectedBettype.betTypId == "5"){  //MULP
        let parent = document.querySelectorAll('#cbetmixinfo > .bet-mix-item-card');
        parent.forEach((child , index)=>{
          bb += child.offsetHeight
        })  

        var heightx = (bb) + 187 //footer
        if(Object.keys(this.$store.getters.betForm).length >= this.$store.getters.betting.minMax.minCombo){
          heightx += document.getElementById('bet_input_defaut_one').offsetHeight  //input keyboard
        }
        if(document.getElementById('betmixcard')!=null){
          heightx += document.getElementById('betmixcard').offsetHeight
        }
      } else {  //bet combo
        let parent = document.querySelectorAll('#singleContainer > .bet-single-item-card');
        let success = []
        if(this.$store.getters.betting.betcombosuccess){
          parent = document.querySelectorAll('#singleContainer > .bet-single-record');
          success = document.querySelectorAll('.bet-success-order');
        }
        
        parent.forEach((child , index)=>{
          bb += child.offsetHeight
        })
        if(parent.length>5){
          bb += 30
        }
        
        if(document.getElementById('betModeZone')!=null){
          bb += document.getElementById('betModeZone').offsetHeight
        }
        if(document.getElementById('betMultiple')!=null){
          bb += document.getElementById('betMultiple').offsetHeight
        }
        if(success.length>0){
          bb += success[0].offsetHeight
        }
        if(document.getElementById('scrollFooter')!=null){
          bb += document.getElementById('scrollFooter').offsetHeight
        }
        var heightx = bb
      }
      
      if(document.getElementById('betviewScroll')!=null){
        document.getElementById('betviewScroll').style.height = heightx +'px'
      }
    },
    updateHightlightOdds() {
      let vue = this
      let bet_form = this.$store.getters.betForm
      $('div.c-bet-item').removeClass('active');
      bet_form.forEach((bet_data , id)=>{
        var MID = bet_data.uniqueId? bet_data.uniqueId:''
        if(MID!='') {
          vue.oddSelectHighlight(MID, bet_data)
        }
      })
    },
    oddSelectHighlight(windowEve, bet_form){
      var MID = typeof windowEve == 'object'? $(windowEve.target).closest('div[id]')[0].id : windowEve  //selected odds id

      //Common
      if(!this.$store.getters.isBetParlay && !this.$store.getters.isBetCombo){ //single
        $('div.c-bet-item').removeClass('active');
      } else if (this.$store.getters.selectedBettype.betTypId=='5' || this.$store.getters.isBetParlay) { //mulp
        let parent = document.querySelectorAll('#cmatch'+bet_form.eveid);
        parent.forEach((child , index)=>{
          var chk = child.querySelector('.c-bet-item.active')
          if(chk!=null){
            chk.classList.remove("active");
          }
        })
        $("[id="+MID+"]").closest('.c-bet-item.active').removeClass('active')
        
        //All-Bet
        var allBetArr = ['ab','firstEvent'] //support center & right menu allbet
        allBetArr.forEach((arrData , id)=>{
          let allBetparent = document.querySelectorAll('#'+arrData+'allBetGroup'+bet_form.eveid);
          allBetparent.forEach((childAllBet , indexAb)=>{
            var allBetchk = childAllBet.querySelector('.c-bet-item.active')
            if(allBetchk!=null){
              allBetchk.classList.remove("active");
            }
          })
        })

        // remove item not include inside bet form 
        if(this.$store.getters.open_RBMarket) {
          // var rmvEveIds = []
          var eveIds = _.map( this.$store.getters.betForm , 'eveid')
          if(!eveIds.includes(bet_form.eveid)) {
            eveIds.push(bet_form.eveid)
          }
          var activeEl = document.querySelectorAll('.c-match-handicap .c-bet-item.active');
          activeEl.forEach(function(el) {
            let parent = el.closest('[id*="cmatch"]');
            if (parent) {
                var eid = parent.id.replace('cmatch','')
                if(!eveIds.includes(Number(eid))){
                  // rmvEveIds.push(eid)
                  var rmtargets = document.querySelectorAll('#'+parent.id+' .c-bet-item.active');
                  rmtargets.forEach(function(rmtarget) {
                    rmtarget.classList.remove("active");
                  });

                  allBetArr.forEach((arrData , id)=>{
                    let allBetrmtargets = document.querySelectorAll('#'+arrData+'allBetGroup'+eid+' .c-bet-item.active');
                    allBetrmtargets.forEach(function(allBetrmtarget) {
                      allBetrmtarget.classList.remove("active");
                    });
                  })
                }
            }
          });
        }
        
      } else if (this.$store.getters.isBetCombo){ //bet combo(multi single)
        if(this.$store.getters.betting.betcombosuccess){
          $('div.c-bet-item.yb-family-odds').removeClass('active');
        }
        var index = _.findIndex(this.$store.getters.betForm, {
          'eveid': bet_form.eveid,
          'plyType': bet_form.plyType,
          'betType': bet_form.betType,
          'dual': bet_form.dual,
        });
        if(index >= 0){
          var rmItemID = '';
          // $("[id="+MID+"]").closest('.c-bet-item.active').removeClass('active')

          let parent = document.querySelectorAll('#handicapCol'+bet_form.eveid+bet_form.betType+bet_form.plyType+bet_form.dual);
          parent.forEach((child , index)=>{
            var chk = child.querySelector('.c-bet-item.active')
            if(chk!=null){
              chk.classList.remove("active");
              rmItemID = chk.querySelector('.odds').id
            }
          })
          
          // more bets table
          var btTemp = [this.csBetType,this.rcsBetType,this.onex2bttsBetType,this.ronex2bttsBetType,this.dbchbttsBetType,this.rdbchbttsBetType]
          if(btTemp.includes(bet_form.betType)) {
            var parentClass = 'morebetcs'
            var betClass = '.bet-cs-'+bet_form.plyType
            if([this.onex2bttsBetType,this.ronex2bttsBetType,this.dbchbttsBetType,this.rdbchbttsBetType].includes(bet_form.betType)) {
              parentClass = 'morebetdual'
              betClass = '.bet-1x2btts'
              if([this.dbchbttsBetType,this.rdbchbttsBetType].includes(bet_form.betType)) {
                betClass = '.bet-dbchbtts'
              }
            }
            let parentCs = document.querySelectorAll('#cmatch'+bet_form.eveid+'.'+parentClass);
            parentCs.forEach((child , index)=>{
              var chk = child.querySelector('.c-bet-item'+betClass+'.active')
              if(chk!=null){
                chk.classList.remove("active");
                rmItemID = chk.querySelector('.odds').id
              }
            })
          }

          // all bet table
          var allBetTarget = $('#aballBetGroup'+bet_form.eveid+' #'+bet_form.uniqueId)
          if(allBetTarget.length > 0){
            var parent = '.handicap'
            if(bet_form.betType == this.edgBetType) {
              parent = '.body_EG_'+bet_form.eveid
            } else if(bet_form.betType == this.wdBetType) {
              parent = '.main-handicap'
            }
            var allBetParent = allBetTarget.closest(parent)
            if(allBetParent.length > 0) {
              var allBetRmTarget = allBetParent[0].querySelector('.c-bet-item.active')
              if(allBetRmTarget != null) {
                allBetRmTarget.classList.remove("active")
                rmItemID = allBetRmTarget.querySelector('.odds').id
              }
            }
          }

          if(rmItemID == '') {
            rmItemID = bet_form.uniqueId
          }

          // right bet table
          if(rmItemID != '') {
           var firstEventParent = $('#firstEventallBetGroup'+bet_form.eveid+' #'+rmItemID)
           if(firstEventParent.length > 0){
            if([this.csBetType,this.rcsBetType].includes(bet_form.betType)){
              var firstEventParent1 = firstEventParent.closest('.handicap-sub-title').parent()
            } else if(bet_form.betType == this.edgBetType) {
              var firstEventParent1 = firstEventParent.closest('.body_EG_'+bet_form.eveid)
            } else if(bet_form.betType == this.wdBetType) {
              var firstEventParent1 = firstEventParent.closest('.main-handicap')
            } else {
              var firstEventParent1 = firstEventParent.closest('.handicap')
            }
            if(firstEventParent1.length > 0) {
              var firstEventTarget = firstEventParent1[0].querySelector('.c-bet-item.active')
              if(firstEventTarget != null) {
                firstEventTarget.classList.remove("active")
              }
            }
           }
          }

          // for cs, tg and htft
          var indvBt = [this.csBetType,this.rcsBetType,this.tgBetType,this.rtgBetType,this.htftBetType,this.rhtftBetType]
          if(indvBt.includes(bet_form.betType)) {
            var betClass = '.bet-cs-'+bet_form.plyType
            if([this.tgBetType,this.rtgBetType,this.htftBetType,this.rhtftBetType].includes(bet_form.betType)) {
              betClass = '.bet-tg-'+bet_form.plyType
              if([this.htftBetType,this.rhtftBetType].includes(bet_form.betType)) {
                betClass = '.bet-htft-'+bet_form.plyType
              }
            }
            let parentCs = document.querySelectorAll('#cmatch'+bet_form.eveid);
            parentCs.forEach((child , index)=>{
              var chk = child.querySelector('.c-bet-item'+betClass+'.active')
              if(chk!=null){
                chk.classList.remove("active");
                rmItemID = chk.querySelector('.odds').id
              }
            })
          }
        }
      }
      
      // document.getElementById(MID).parentElement.classList.add('active')
      $("[id="+MID+"]").closest('.c-bet-item').addClass('active')
    },
    checkBetComboMax(bet_form) {
      var index = _.findIndex(this.$store.getters.betForm, {
        'eveid': bet_form.eveid,
        'plyType': bet_form.plyType,
        'betType': bet_form.betType,
        'dual': bet_form.matchId,
      });
      if(index < 0){
        let VUE = this
        VUE.$store.commit('COMBOBET_EXCEEDLIMIT', true)

        setTimeout(function(){
          VUE.$store.commit('COMBOBET_EXCEEDLIMIT', false)
        },5000)
        return true
      }
    },
    showHideAllBet(key) {
      var expanded = $('#triggertoggle').hasClass('icon-open')

      if(expanded){
          $('#triggertoggle').removeClass('icon-open')
          $('#triggertoggle').addClass('icon-close')
          $(key).css("display", "none");
      }else{
          $('#triggertoggle').addClass('icon-open')
          $('#triggertoggle').removeClass('icon-close')
          $(key).css("display", "");
      }
    },
    checkMiniBetUnique(event, oddUniqueId) {
      if(this.$store.getters.betForm.length > 0) {
        var plyTyp = this.$store.getters.betForm[0].plyType
        if(this.$store.getters.betForm[0].uniqueId == oddUniqueId && this.checkEventPlyTypExist(event, plyTyp)) {
          return true
        }
      }

      return false
    },
    checkOTRMiniBetUnique(event, oddUniqueId) {
      if(this.$store.getters.betForm.length > 0) {
        var plyTyp = this.$store.getters.betForm[0].plyType
        if(this.$store.getters.betForm[0].uniqueId == oddUniqueId) {
          return true
        }
      }

      return false
    },
    selectCell(event,team) {
      if(this.highlightedCell != this.$refs[team][0]["_uid"]){
        $('td').removeClass('bg_yellow')    
      }
      this.$store.commit('HIGHLIGHT_CELL', this.$refs[team][0]["_uid"])
      this.$refs[team][0].onClickOdd()
      this.$forceUpdate()
      return
    },
    highlight(team){
      if(Object.keys(this.$refs).length > 0){
        if(this.$refs[team].length > 0){
          if(this.$refs[team][0]["_uid"] == this.highlightedCell){
            return 'bg_yellow'
          }
        }
        return 'bg_white'
      }
      return 'bg_white'
    },
    isPrior() {
      if(this.event && this.plytyp){
        if(!_.isUndefined(this.event.prior)){
          if(this.$store.getters.selectedBettype.sprtId == 'G2') {
            return false
          }
          else if(this.event.prior.indexOf(parseInt(this.plytyp)) >= 0 ) {
            return true
          }
          return false
        }
      }
    },
    getplytype(eventOD) {

      return Object.keys(eventOD)[0]
    },
    getFullTime(eveod) {
      var pt = this.ftPlyType
      var arr_pt = Object.keys(eveod)

      if(arr_pt.length > 0 && ($.inArray(this.ftPlyType, arr_pt) > -1)) {
        pt = this.ftPlyType
      } else if(arr_pt.length > 0 && ($.inArray(this.setHandicapPlyType, arr_pt) > -1)) {
        pt = this.setHandicapPlyType
      }

      return pt
    },
    getSubMatchCount(plyType) {
      var count = 0

      // Handle hdp,ou odds not open
      var noSubMatchBettyp = [this.onex2BetType, this.ronex2BetType, this.mlBetType, this.rmlBetType, this.edgBetType]
      _.forEach(plyType, function(value, bettype) {
        if( noSubMatchBettyp.indexOf(bettype) == -1 ) {
          if(Object.keys(value).length >= count) {
            count = Object.keys(value).length
          }
        }
        else if( noSubMatchBettyp.indexOf(bettype) >= 0 && count == 0 ) {
          count = 1;
        } 
      });

      return (count > 0)? count:1
    },
    getSubMatchCountRow(plyType,sprt) {
      var count = 0
      // these bt has submatch
      var subMatchBettyp = [ this.ouBetType, this.rouBetType, this.hdpBetType, this.rhdpBetType]
      _.forEach(plyType, function(btdata, ptid) {
        if(sprt==1 || (sprt>1 && (ptid==1 || ptid==3))){

        
          _.forEach(btdata, function(val, btid) {

            // if(subMatchBettyp.indexOf(bettype) != -1 ) {
            if(subMatchBettyp.indexOf(btid) != -1 ) {
              let b = Object.keys(val).length + ' ' +count
              if(Object.keys(val).length >= count) {
                count = Object.keys(val).length
              }
            // } else if( subMatchBettyp.indexOf(bettype) >= 0 && count == 0 ) {
            } else if( subMatchBettyp.indexOf(btid) >= 0 && count == 0 ) {
              count = 1;
            } 
          });
        }
      });

      return count
    },
    checkEventPlyTypExist(event, plytyp) {
      var isExist = false
      if(typeof event.od != 'undefined' ){
        if(typeof event.od[plytyp] != 'undefined' ) {
          isExist = true
        }
      }
      return isExist
    },
    checkEventPlyTypExist2(event) {
      var isExist = false
      if(typeof event.od != 'undefined' ){
        _.forEach(this.osCommon, function(plytype, index) {
          if(typeof event.od[plytype] != 'undefined' ) {
            isExist = true
            return false
          }
        });
        return isExist
      }
    },
    checkEventPlyTypIndex(event, plytyp) {
      var firstindex = false
      if(typeof event.od != 'undefined' ){
        if(typeof event.od[plytyp] != 'undefined' ) {
          var index = Object.keys(event.od).indexOf(plytyp)
          if(index==0){
            firstindex = true
          }
        }
      }
      return firstindex
    },
    getDecimalDisplay(value) {
      if(this.$store.getters.account.oddsType=='am' && !this.$store.getters.specialEvent){
        return parseFloat(value).toFixed(0);
      }
      return parseFloat(value).toFixed(2);
    },
    checkOddValidation(value) {
      if(this.$store.getters.account.oddsType=='am'){
        var pass_value= parseFloat(value);
        if(pass_value<0){
          pass_value=Math.abs(100/pass_value);
        }else{
          pass_value=pass_value/100;
        }
        pass_value=pass_value.toFixed(3);
        if(pass_value<=0){
          return false;
        }
      }else{
        if(parseFloat(value)<1){
          return false;
        }
      }
      
      return true;
    },
    validateOddHdp(args) {
      //odds, bettype, oddtype
      //ah, rah, ou, rou
      var ahou = [1, 8, 2, 9, 46, 47, 48, 49, 80, 81, 82, 83]
      var rahrou = [2, 9, 46, 47, 48, 49, 80, 81, 82, 83]
      var oeroe = [3, 10]
      var oddtype1 = ['my', 'in']
      var oddtype2 = ['hk', 'in', 'eu']
      if( args.odds == 0 ) {
        return false
      }
      if(oddtype1.indexOf(args.oddstype) == -1){
        if (ahou.indexOf(args.bettype) != -1) {
          if (args.oddstype == 'eu') {
            if (args.odds <= 1) {
              return false
            }
          }
          else if (args.oddstype == 'hk') {
            if (args.odds <= 0) {
              return false
            }
          }
          if (rahrou.indexOf(args.bettype, [2, 9, 46, 47, 48, 49, 80, 81, 82, 83]) != -1) {
            if(args.hdp){
              if (Math.abs(args.hdp) == 0) {
                return false
              }
            }
          }
        }
        //oe, roe
        else if (oeroe.indexOf(args.bettype) != -1) {
          if (oddtype2.indexOf(args.oddstype) != -1 && args.odds <= 1) {
            return false
          }
        }
        else {
          if (args.odds <= 1 && args.oddstype!="am") {
            return false
          }
        }
      }
      return true
    },
    //for possiblepayout use
    validateOddBetType(betTyp, odd) {

      if(this.$store.getters.account.oddsType=='am'){
        if(odd<0){
          odd=Math.abs(100/odd);
        }else{
          odd= (odd / 100);
        }
        odd= odd.toFixed(3);
      }else if( (betTyp == this.ronex2BetType || betTyp == this.onex2BetType ||
        betTyp == this.mlBetType || betTyp == this.rmlBetType ||
        betTyp == this.oeBetType || betTyp == this.roeBetType ||
        betTyp == this.tgBetType || betTyp == this.htftBetType ||
        betTyp == this.csBetType || betTyp == this.otrBetType ||
        betTyp == this.rcsBetType || betTyp == this.rhtftBetType || 
        betTyp == this.rtgBetType || betTyp == this.dbchBetType || 
        betTyp == this.rdbchBetType ||
        betTyp == this.h1x2BetType ||
        betTyp == this.wdBetType ||
        betTyp == this.rh1x2BetType ||
        betTyp == this.hmgBetType ||
        betTyp == this.rhmgBetType ||
        betTyp == this.hmg1x2BetType ||
        betTyp == this.rhmg1x2BetType ||
        betTyp == this.bttsBetType ||
        betTyp == this.rbttsBetType ||
        betTyp == this.cshBetType ||
        betTyp == this.rcshBetType ||
        betTyp == this.twnBetType ||
        betTyp == this.rtwnBetType ||
        betTyp == this.twfbBetType ||
        betTyp == this.rtwfbBetType ||
        betTyp == this.twehBetType ||
        betTyp == this.rtwehBetType ||
        betTyp == this.twbhBetType ||
        betTyp == this.rtwbhBetType ||
        betTyp == this.tsbhBetType ||
        betTyp == this.rtsbhBetType ||
        betTyp == this.wmBetType ||
        betTyp == this.rwmBetType ||
        betTyp == this.flgBetType ||
        betTyp == this.hldsBetType ||
        betTyp == this.aldsBetType ||
        betTyp == this.rhldsBetType ||
        betTyp == this.raldsBetType ||

        betTyp == this.nogBetType ||
        betTyp == this.rnogBetType ||
        betTyp == this.ouoeBetType ||
        betTyp == this.rouoeBetType ||
        betTyp == this.oubttsBetType ||
        betTyp == this.roubttsBetType ||
        betTyp == this.ouftsBetType ||
        betTyp == this.onex2ouBetType ||
        betTyp == this.ronex2ouBetType ||
        betTyp == this.onex2bttsBetType ||
        betTyp == this.ronex2bttsBetType ||
        betTyp == this.onex2ftsBetType ||
        betTyp == this.dcouBetType ||
        betTyp == this.rdcouBetType ||
        betTyp == this.dcbttsBetType ||
        betTyp == this.rdcbttsBetType ||
        betTyp == this.dcftsBetType ||
        betTyp == this.edgBetType||
        betTyp == this.rwmrBetType ||
        betTyp == this.wmrBetType ||
        betTyp == this.rexiBetType ||
        betTyp == this.exiBetType 
        ) && odd > 1 ) {
        if(betTyp == this.oeBetType || betTyp == this.roeBetType) {
          odd = (!this.$store.getters.oddTypesList.IN || this.$store.getters.account.oddsType != this.$store.getters.oddTypesList.IN.key) ? odd - 1 : odd
        } else {
          odd -= 1
        }
      }else if(this.$store.getters.account.oddsType == this.$store.getters.oddTypesList.EU.key && odd > 1) {
        odd -= 1
      }
      return odd
    },
    jsMinMaxValidation(betAmount, isMulp = false, selectedBetAllup = null){
      if(parseInt(betAmount) > parseFloat(this.account.currCL)){
        return { errorId:1, error: true, msg: this.betLang['BETTING.LBL_NO_CREDIT'] }
      }else if(parseInt(betAmount)!=0 && parseInt(betAmount) < this.betting.minMax.min){
      // }else if(parseInt(betAmount) < this.betting.minMax.min){
        return { errorId:2, error: true, msg: this.betLang['BETTING.LBL_WRONG_MIN']+ ' ' + this.betting.minMax.min }
      }else if(parseInt(betAmount) > this.betting.minMax.max){
        return { errorId:3, error: true, msg: this.betLang['BETTING.LBL_WRONG_MAX']+ ' ' + this.betting.minMax.max }
      }else if(parseInt(betAmount)==0){
        return { errorId:4, error: true, msg: this.betLang['BETTING.PLEASE_ENTER_STAKE']}
      }

      if(isMulp && selectedBetAllup!=null){
        // var wager = this.betAllUp.split('x');
        // var wager = this.betting.selectedBetAllup.split('x');
        var wager = selectedBetAllup.split('x');
        
        if ((parseInt(betAmount) * parseInt(wager[1])) > parseFloat(this.account.currCL)) {
          return { errorId:4, error: true, msg: this.betLang['BETTING.LBL_NO_CREDIT'] }
        }else if(this.betForm.length < this.betting.minMax.minCombo){
          var minCombo = this.betLang['BETTING.LBL_WRONG_MIN_COMBO']
          minCombo = minCombo.replace('{minCombo}', this.betting.minMax.minCombo)
          return { errorId:5, error: true, msg: minCombo}
        }else if(this.betForm.length > this.betting.minMax.maxCombo){
            var maxCombo = this.betLang['BETTING.LBL_WRONG_MAX_COMBO']
            maxCombo = maxCombo.replace('{maxCombo}', this.betting.minMax.maxCombo)
            return { errorId:6, error: true, msg: maxCombo}
        }
      }
      return { error: false }
    },
    commasAmount(amount) {
      amount += '';
      var x = amount.split('.');
      var x1 = x[0];
      var x2 = x.length > 1 ? '.' + x[1] : '';
      var rgx = /(\d+)(\d{3})/;
      while (rgx.test(x1)) {
        x1 = x1.replace(rgx, '$1' + ',' + '$2');
      }
      return x1 + x2;
    },
    checkInPly() {
      if (!this.showFavEvents && this.$store.getters.selectedMarket == this.$store.getters.market.inPlayMarket.key || 
        // (this.$store.getters.istodayRB && this.$store.getters.selectedMarket == this.$store.getters.market.tdyMarket.key) || 
        (this.$store.getters.selectedMatchAllBet && this.$store.getters.firstEvent && this.$store.getters.firstEvent.rb && this.$store.getters.firstEvent.rbstatus) || 
        (this.$store.getters.open_RBMarket)
        ) {
        this.hdpBetType = _.cloneDeep(this.rhdpBetType)
        this.ouBetType = _.cloneDeep(this.rouBetType)
        this.oeBetType = _.cloneDeep(this.roeBetType)
        this.onex2BetType = _.cloneDeep(this.ronex2BetType)
        this.mlBetType = _.cloneDeep(this.rmlBetType)
        this.htgBetType = _.cloneDeep(this.rhtgBetType)
        this.atgBetType = _.cloneDeep(this.ratgBetType)
        this.bttsBetType = _.cloneDeep(this.rbttsBetType)
        this.wmBetType = _.cloneDeep(this.rwmBetType)
        this.twnBetType = _.cloneDeep(this.rtwnBetType)
        this.twfbBetType = _.cloneDeep(this.rtwfbBetType)
        this.twehBetType = _.cloneDeep(this.rtwehBetType)
        this.twbhBetType = _.cloneDeep(this.rtwbhBetType)
        this.tsbhBetType = _.cloneDeep(this.rtsbhBetType)
        this.cshBetType = _.cloneDeep(this.rcshBetType)
        this.h1x2BetType = _.cloneDeep(this.rh1x2BetType)
        this.hmgBetType = _.cloneDeep(this.rhmgBetType)
        this.hmg1x2BetType = _.cloneDeep(this.rhmg1x2BetType)
        this.hldsBetType = _.cloneDeep(this.rhldsBetType)
        this.aldsBetType = _.cloneDeep(this.raldsBetType)
        this.nogBetType = _.cloneDeep(this.rnogBetType)
        this.oubttsBetType = _.cloneDeep(this.roubttsBetType)
        this.onex2ouBetType = _.cloneDeep(this.ronex2ouBetType)
        this.onex2bttsBetType = _.cloneDeep(this.ronex2bttsBetType)
        this.ouoeBetType = _.cloneDeep(this.rouoeBetType)
        this.dbchouBetType = _.cloneDeep(this.rdbchouBetType)
        this.dbchbttsBetType = _.cloneDeep(this.rdbchbttsBetType)
        this.wmrBetType = _.cloneDeep(this.rwmrBetType)
        this.exiBetType = _.cloneDeep(this.rexiBetType)
        this.htrBetType = _.cloneDeep(this.rhtrBetType)
        this.atrBetType = _.cloneDeep(this.ratrBetType)
      } else {
        this.hdpBetType = '1'
        this.ouBetType = '2'
        this.oeBetType = '3'
        this.onex2BetType = '4'
        this.mlBetType = '12'
        this.htgBetType = '46'
        this.atgBetType = '48'
        this.bttsBetType = '32'
        this.wmBetType = '50'
        this.twnBetType = '36'
        this.twfbBetType = '38'
        this.twehBetType = '40'
        this.twbhBetType = '42'
        this.tsbhBetType = '44'
        this.cshBetType = '34'
        this.h1x2BetType = '21'
        this.hmgBetType = '28'
        this.hmg1x2BetType = '30'
        this.hldsBetType = '53'
        this.aldsBetType = '54'
        this.nogBetType = '57'
        this.ouoeBetType = '59'
        this.oubttsBetType = '60'
        this.onex2ouBetType = '63'
        this.onex2bttsBetType = '65'
        this.dbchouBetType = '68'
        this.dbchbttsBetType = '70'
        this.exiBetType= '76',
        this.wmrBetType= '77',
        this.htrBetType= '80',
        this.atrBetType= '82'
      }
    },
    checkPlayType() {
      if (this.$store.getters.selectedBettype.sprtId == 'G1') {
        this.plytyp = this.ftPlyType
      } else if (this.$store.getters.selectedBettype.sprtId == 'G2') {
        this.plytyp = this.ftPlyType
      } else if (this.$store.getters.selectedBettype.sprtId == 'N15') {
        this.plytyp = this.ftPlyType
      } else {
        this.plytyp = this.setHandicapPlyType
      }
    },
    cancelMiniBet() {
      var sportMiniBet = this.$store.getters.sportMiniBet
      sportMiniBet.toggle = false
      this.$store.commit('SPORT_MINIBET', sportMiniBet)
    },
    showMiniBet(windowEvent) {
      var quickbet = ['1','2','3','4','6','7','8']
      // this.$refs.betAmount
      if (!this.$store.getters.selectedAllBet) {
        var tmpltId = this.$store.getters.selectedBettype.tmpltId
        //if is common, outright(6) and not parlay
        if (this.$store.getters.sportMiniBet.allow && (quickbet.includes(tmpltId)) && this.$store.getters.selectedBettype.betTypId != '5') {
        // if (this.$store.getters.sportMiniBet.allow && (tmpltId == '1' || tmpltId == '6' || tmpltId == '7' || tmpltId == '8') && this.$store.getters.selectedBettype.betTypId != '5') {
          if(this.checkEventExist() || !this.$store.getters.sportMiniBet.toggle) {
            this.$store.commit('SPORT_MINIBET_TOGGLE', true)
            this.$store.commit('SPORT_MINIBET_WINDOWEVENT', windowEvent)
            EventBus.$emit('SHOW_MINIBET')

            var w = $('#mainArea').width();
            var el = $(windowEvent.target.parentElement).position();
            var p = ((w - el.left) / w) * 100
            if(23 > p){
              this.$store.commit('SPORT_MINIBET_RIGHTSIDE', true)
            } else {
              this.$store.commit('SPORT_MINIBET_RIGHTSIDE', false)
            }
          } else {
            // this.$store.commit('SPORT_MINIBET_TOGGLE', false) //do not close mini when select another odd
          }
        } else {
          //mulp
          if (this.$store.getters.sportMiniBet.allow) {
            // if(this.checkEventExist() || !this.$store.getters.sportMiniBet.toggle) {
              this.$store.commit('SPORT_MINIBET_TOGGLE', true)
              this.$store.commit('SPORT_MINIBET_WINDOWEVENT', windowEvent)
              EventBus.$emit('SHOW_MINIBET')
            // }
          }
        }
      }
    },
    showSubMatch(subMatchKey, event, smkey, isRB=null) { 
      var showSubMatch = false
      var maxSubMatchOdd = 1 //a is main event, b onwards is submatch
      // var maxSubMatchOdd = 0
      if (typeof event.od != 'undefined') {
        //soccer see if this 3 bettype exist before show submatch
        if (this.$store.getters.selectedBettype.sprtId != 'N1') {
          showSubMatch = true
        } else {
          for (var plytyp = 0; plytyp < Object.keys(event.od).length; plytyp++) {
            var plytypKey = Object.keys(event.od)[plytyp]
            for (var bettyp = 0; bettyp < Object.keys(event.od[plytypKey]).length; bettyp++) {
              var bettypKey = Object.keys(event.od[plytypKey])[bettyp]
              if (bettypKey == this.rhdpBetType || bettypKey == this.hdpBetType ||
                bettypKey == this.rouBetType || bettypKey == this.ouBetType ||
                bettypKey == this.roeBetType || bettypKey == this.oeBetType) {
                var bettypeOddLength = Object.keys(event.od[plytypKey][bettypKey]).length
                if (bettypeOddLength >= maxSubMatchOdd) {
                  maxSubMatchOdd = bettypeOddLength
                }
              }
            }
          }
          if (maxSubMatchOdd >= subMatchKey) {
            showSubMatch = true
          }

          // if (smkey==0 && maxSubMatchOdd >= subMatchKey) {
          //   showSubMatch = true
          // }else if (smkey>0 && maxSubMatchOdd > subMatchKey) {
          //   showSubMatch = true
          // }
        }
      }
      if(this.$store.getters.selectedMarket == this.$store.getters.market.inPlayMarket.key && subMatchKey == 1) {
        showSubMatch = true
      }
      // if (this.$store.getters.selectedMarket == this.$store.getters.market.earlyMarket.key) {
      //   showSubMatch = true
      // }
      if (this.$store.getters.selectedMarket == this.$store.getters.market.tdyMarket.key && subMatchKey == 1 && (isRB || isRB==null)) {
        showSubMatch = true
      }
      
      return showSubMatch
    },
    checkEventExist() { 
      var isExist = false
      if(this.$store.getters.betForm.length > 0) {
        var events = this.$store.getters.eventList
        for (let lgIndex = 0; lgIndex < Object.keys(events).length; lgIndex++) {
          const key = Object.keys(events)[lgIndex];
          if(typeof events[key] == 'object'){
            for (let eventIndex = 0; eventIndex < Object.keys(events[key]).length; eventIndex++) {
              var event = events[key]
              var betFormData = this.$store.getters.betForm[0]
              if(betFormData.eveid == event.eveid) {
                isExist = true
              }
            }
          } else {
            for (let eventIndex = 0; eventIndex < events[key].length; eventIndex++) {
              var event = events[key][eventIndex]
              var betFormData = this.$store.getters.betForm[0]
              if(betFormData.eveid == event.eveid) {
                isExist = true
              }
            }
          }
          
        }
      }
      return isExist
    },
    openTv(match){
      var eveid = match.eveid
      var sprtid = this.$store.getters.selectedBettype.sprtId
      var lang = window._langid
      var spread = this.$store.getters.account.spread
      var odd = this.$store.getters.account.oddsType
      var schedule = this.$store.getters.selectedMarket
      var plytypgrp = 1
      var sptid = match.sptid
      var chid = match.ch
      var lgecapt = match.lgecapt
      var tacapt = match.tacapt
      var tbcapt = match.tbcapt
      var date = 0

      if(sprtid.indexOf('G') >= 0) {
        sprtid = 'N' + match.sptid
      }

      var url = 'livetv?action=allBet'
      url += '&eveid='+eveid
      url += '&sprtid='+sprtid
      url += '&lang='+lang
      url += '&spread='+spread
      url += '&odd='+odd
      url += '&schedule='+schedule
      url += '&date='+date
      url += '&sptid='+sptid
      url += '&chid='+chid
      url += '&lgecapt='+lgecapt
      url += '&tacapt='+tacapt
      url += '&tbcapt='+tbcapt

      window.windowTv = window.open(url, 'MsgWindow', 'width=1050, height=700')
    },
    validateRBTimer(event) {
      if(event.rbinfo.tlsec == -1){
        return false
      }
      var timerMin = moment.duration(event.rbinfo.tlsec,'seconds').minutes()
      var timerHour = moment.duration(event.rbinfo.tlsec,'seconds').hours()
      if(validateSpecialRBTimer(event, timerHour, timerMin)) {
        return '2'
      }
      else if (event.rbinfo.htst == '1') {
        return '1'
      }
      else if (event.rbinfo.htst == '2') {
        return '2'
      }

      return false;
    },
    specialLeagueCaption(event, bettype) {
      var retCapt = ''
     // if(bettype == this.ouBetType || bettype == this.oeBetType || bettype == this.hdpBetType || bettype == this.onex2BetType) {
        if( event.spcapt ) {
          retCapt = event.spcapt
          // retCapt = event.spcapt + ' - '
        }
     // }

      return retCapt
    },
    chgBettype(selBetType=null) {
      if(selBetType==null){
        if(this.selectedBettype.sprtId=='N1'){ //sc
          selBetType = '1'
        } else if(this.selectedBettype.sprtId=='G1'){ //bk
          selBetType = '7'
        }
      }
      var bettype = {}
      for(var i = 0; i < this.portBettypeList.length; i += 1) {
        if(this.portBettypeList[i]['sprtId'] === this.selectedBettype.sprtId) {
          if(this.portBettypeList[i]['betTypId']===selBetType){  //parlay
            bettype = this.portBettypeList[i]
          }
        }
      }

      if(this.$store.getters.selectedMarket=='1'){
        this.$store.commit('SELECTEDEARLYPARLAYDATE', this.todayDate)
      } else {
        this.$store.commit('SELECTEDEARLYPARLAYDATE', this.allDate)
      }
      this.$store.commit("GAMEBANNER_SELECTED", false);
      this.$store.commit('STATEMENT_SHOW_STATEMENT', false)
      this.$store.commit('SELECTED_ALLBET', false)
      this.$store.commit('SELECTED_MATCHALLBET', false)
      this.$store.commit('SPORT_SHOW_FAV_EVENTS', false)
      // this.$store.commit('SELECTED_LEAGUELIST', [])
      EventBus.$emit('refreshOdd', true);
      EventBus.$emit('viewAccountSetting', false)
      if(bettype){
        //get latest-info used purpose
        if(bettype.betTypId == '5' && this.$store.getters.sportPrevIsMulp) {
          this.$store.commit('SPORT_PREVIOUS_IS_MULP', true)
        } else {
          this.$store.commit('PARLAY_SELECTED', {update : false})
          this.$store.commit('SPORT_PREVIOUS_IS_MULP', false)
        }
        this.$store.commit('SELECTED_BETTYPE', _.cloneDeep(bettype))
      } else {
        var temp = this.$store.getters.selectedBettype
        temp.betTypId = null
        temp.tmpltId = null
        this.$store.commit('SELECTED_BETTYPE', _.cloneDeep(temp))
      }
      EventBus.$emit('sportChange', this.$store.getters.selectedBettype );
    },
    selectWDCell(event,team) {
      if(this.highlightedCell != this.$refs[team][0]["_uid"]){
        $('div').removeClass('bg_yellow')    
      }
      this.$store.commit('HIGHLIGHT_CELL', this.$refs[team][0]["_uid"])
      this.$refs[team][0].onClickOdd()
      this.$forceUpdate()
      return
    },
    chkMoreBetExist(event, isRB) {
      let vue = this
      let exist = false
      let arr = (isRB) ? this.moreRBBetTab : this.moreBetTab

      _.forEach(event.od, function (ptydata, key) {
        _.forEach(ptydata, function (val, k) {
          if ($.inArray(k, arr) > -1) {
            exist = true
          }
        })
      })

      if(event.sp) {
        _.forEach(event.sp, function (val, key) {
          if ($.inArray(val.r, ["b","c"]) > -1) {
            exist = true
          }
        })
      }

      if(this.$store.getters.simpleSport!=null) {
        exist = true
      }

      return exist
    },
    eventHeight(eveData, eCard, isRB=false){
      // morebet:32|submatch:70|main:105
      var subH = 0
      var subM = 0
      var card = (eCard=='ecw') ? 5 : 2
      var exist = this.chkMoreBetExist(eveData, isRB)
      var morebet = (exist) ? this.moreBetHeight : 0
      var OSsub = eveData.sub //submatch without knowing on/off
      var countSub = this.getSubMatchCountRow(eveData['od'],eveData['sptid'])
      // var countSub = this.getSubMatchCountRow(eveData['od'][this.getplytype(eveData['od'])])
      OSsub = (countSub - 1)
      // if(eveData.sptid != 1){
        // OSsub = this.getSubMatchCount(eveData['od'][this.getplytype(eveData['od'])])
        // OSsub = countSub - 1 
      // }else{ //sc
        //check sub status on/off
        //counted a, b = 2 (sub match count shud be 1)
        // if((countSub-1) < OSsub){
          // OSsub = (countSub - 1)
        // }
      // }
      
      // submatch height
      if(OSsub>0 && Object.keys(eveData.od).length>0){
        subM = (OSsub * this.subMatchHeight)
      }
      subH = this.commonMatchHeight + subM + card + morebet
      if(this.$store.getters.simpleSport!=null || this.$store.getters.specialEvent) {
        subH -= subM
        subH -= 55
      }

      return 'height: '+subH+'px'
    },
    backtoTop() {
      $('.scroll-inner-wrap').animate({
        scrollTop: $('.wrap-scroll').position().top
      }, 400);
    },
    isUsingPhone() {
      // return /iPhone|Android|Mobile|iPad|Tablet|/i.test(navigator.userAgent) ? 1 : 0;
      return /Android|webOS|iPhone|iPad|iPod|Opera Mini/i.test(navigator.userAgent) ? 1 : 0;
    },
    setbetMulpKeyboard(key){
      var betMulpAmtArr = this.$store.getters.betMulpAmount[key]
      var amount = (betMulpAmtArr.value == '') ? 0 : betMulpAmtArr.value.replaceAll(",", "")
      var arr = {
        index: key,
        allUp: betMulpAmtArr.allUp,
        amount: (betMulpAmtArr.value == '') ? '' : amount
      }
      this.betMulpAmount = arr
    },
    totalBet1(key){
      var tb = key.split('x')
      return tb.length>1? tb[1]:'0'
    },
    mulpPossiblePayout(arr) {
      var id = arr.index
      var allUp = arr.allUp
      var amt = arr.amount
      var ret = {
        index: id,
        allUp: allUp,
        amount: '',
        stake: '',
        possiblePayout: '',
        maxPay: this.$store.getters.betMulpAmount[id].maxPay
      }
      if(this.isMulp && (!_.isUndefined(this.betting.allUpList[id])&&this.betting.allUpList[id].key==allUp) && id>=0 && amt!='' && amt>=0) {
        ret.amount = amt
        var allUpKey = this.betting.allUpList[id].key
        var totalBetSlip = allUpKey.split('x')
        ret.stake = Number(amt) * parseInt(totalBetSlip[1])

        var retpossiblePayout = 0
        var oddValue = ""
        var mulpParser = this.betting.allUpList[id].parser.split("#");
        for (let index = 0; index < mulpParser.length; index++) {
          const commaList = mulpParser[index].split(",");
          var ttlOdds = 1;
          oddValue = "";
          for (let comma = 0; comma < commaList.length; comma++) {
            const betData = this.$store.getters.betForm[commaList[comma]];
            var betOdd = parseFloat(betData.odd);
            if(this.$store.getters.account.oddsType=='am'){
              if(betOdd<0){
                betOdd=Math.abs(100/betOdd)+1;
              }else{
                betOdd= (betOdd / 100)+1;
              }
             //alert(betOdd)
              betOdd= betOdd.toFixed(3);
            }
            ttlOdds *= betOdd;
          }
          oddValue = ttlOdds - 1;
          retpossiblePayout += Number(amt) * oddValue;
        } 
        ret.possiblePayout = retpossiblePayout
      } 
      return ret
    },
    displayMulpPossiblePayout(index){
      return this.betMulpAmount[index].possiblePayout == ''? 0 :this.betMulpAmount[index].possiblePayout.replaceAll(",", "")
    },
    countMaxOdds(id){
        var oddValue = ""
        var retpossiblePayout = 0
      var mulpParser = this.betting.allUpList[id].parser.split("#");
      let oddslist = {};
      for (let index = 0; index < mulpParser.length; index++) {
        const commaList = mulpParser[index].split(",");
        var ttlOdds = 1;
        oddValue = "";
        for (let comma = 0; comma < commaList.length; comma++) {
          const betData = this.$store.getters.betForm[commaList[comma]];
          var betOdd = parseFloat(betData.odd);
          if(this.$store.getters.account.oddsType=='am'){
            if(betOdd<0){
              betOdd=Math.abs(100/betOdd)+1;
            }else{
              betOdd= (betOdd / 100)+1;
            }
            betOdd= betOdd.toFixed(3);
          }
          ttlOdds *= betOdd;
        }
        oddValue = ttlOdds - 1;
        // check if the odd value os more than max odds (999)
        if(oddValue > this.betting.minMax.maxOdds){
          return false;
        }
      } 
      return true;
    },
    countTotalStakePayout(type, success=false) {
      var sum = 0
      if(success){
        if(this.$store.getters.betting.pending) {
          var dt = this.$store.getters.betting.pending.data && this.$store.getters.betting.pending.data.mulpRes? this.$store.getters.betting.pending.data.mulpRes: false
        } else {
          var dt = this.$store.getters.betting.success.data && this.$store.getters.betting.success.data.mulpRes? this.$store.getters.betting.success.data.mulpRes: false
        }
        var betMulpAmount = this.$store.getters.betMulpAmtFiltered
        if(dt!=false){
          $.each(dt,function(id,data){
            if(data.WagerID!=undefined){
              if(type == 'possiblePayout') {
                var value = betMulpAmount[id].possiblePayout.replaceAll(",", "")
                sum += value==''?0:Number(value)
              } else if(type == 'totalStake'){
                var value = data.amount? data.amount : betMulpAmount[id].stake.replaceAll(",", "")
                sum += value==''?0:Number(value)
              } else if(type == 'totalBet'){
                sum++
              }
            }
          });
        }
      } else {
        $.each(this.$store.getters.betMulpAmount,function(id,data){
          if(type == 'possiblePayout') {
            var value = data.possiblePayout.replaceAll(",", "")
            sum += value==''?0:Number(value)
          } else if(type == 'totalStake'){
            var value = data.stake.replaceAll(",", "")
            sum += value==''?0:Number(value)
          } else if(type == 'totalBet'){
            var value = data.value.replaceAll(",", "")
            if(value != '' && Number(value) != 0){
              sum++
            }
          }
        });
      }
      if(type == 'totalBet' && sum<=0){
        sum = ''
      }
      return sum
    },
    multipleBetClick(){
      this.multipleBetToggle = !this.multipleBetToggle
    },
		getMULPOdds(){
			var odds = 0
			var vue = this
      if(this.betFormList){
        _.forEach(this.betFormList, function(data, key){
          var pass_value= parseFloat(data.odd);
          if(vue.$store.getters.account.oddsType=='am'){
            if(pass_value<0){
              pass_value=Math.abs(100/pass_value)+1;
            }else{
              pass_value=(pass_value/100)+1;
            }
            pass_value=pass_value.toFixed(2)
          }
          if(odds == 0){
            odds = parseFloat(pass_value)
          }else{
            odds = parseFloat(odds) * parseFloat(pass_value)
          }
        })
      }
      
      // check if exceed max odds / max pay
      if(this.betting && this.betting.minMax){
        if(this.betting.minMax.maxOdds){
          if(odds > parseFloat(this.betting.minMax.maxOdds)){ //parseFloat(this.betting.minMax.maxOdds)
            // show error msg, cannot bet
            if(this.mulpOdds != odds){
              this.mulpOdds = odds
              var message = this.betLang['BETTING.EXCEED_MAX_ODDS']+' '+this.betting.minMax.maxOdds
              this.$store.commit('JS_ERR', {error:true, msg:message})
              this.$store.commit('DISABLE_BET',true)
              this.$store.commit('DIALOG_TOGGLE',{
                show: true,
                msg: message
              })
              setTimeout(function(){
                vue.$store.commit('DIALOG_TOGGLE', {reset:true})
              },5000)
              // var err = {code:"", message:msg}
              // this.$store.commit('BETTING_MESSAGE', {
              //   isError: true,
              //   data: err
              // })
            }
          } else {
            this.mulpOdds = odds
            this.$store.commit('DISABLE_BET',false)
            this.$store.commit('JS_ERR', {error:false})
            // if(this.betting.minMax.maxPay && this.betting.minMax.max){
            //   var maxPay = parseFloat(this.betting.minMax.maxPay) / odds
            //   if(parseFloat(this.betting.minMax.max) < maxPay){
            //     this.$store.commit('BETTING_CHIP_OPTION', {
            //       setMax: true,
            //       max: maxPay.toFixed(2)
            //     })
            //   }
            // }
          }
        }
      }
      // return odds result
      if(this.$store.getters.account.oddsType=='am'){
        if(odds>1){
          if(odds>=2){
            odds = 100 * (odds -1)
          }else{
            odds = -100 / (odds -1)
          }
        }else{
          odds = 0
        }
        if(odds > 0){
          odds = Math.floor(odds)
        }else{
          odds = parseFloat(odds).toFixed(0);
        }
      }else{
        // odds = odds.toFixed(2)
        odds = Math.floor(odds * 100)/100
      }
			return odds
		},
    showKeyboard(key,index){
      this.$store.commit('SELECTED_MULP_BOX', index)
      if(this.$store.getters.betMulpAmount && this.$store.getters.betMulpAmount.length>1){
        $('.mulp_keyboard').hide()
        $('.mulp_keyboard.'+key).show()
      }
    },
    betMinMaxMulp(index) {
      return this.sportAllBetLang['ALL_BET.LIMITS'] + ' ' + this.commasAmount(this.$store.getters.betting.minMax.min) + ' ~ ' + this.commasAmount(this.$store.getters.betMulpAmount[index].maxPay)
    },
  },
  mounted() {
    this.checkInPly()
    EventBus.$on(['marketChange', 'sportChange', 'pageChange'], ((params) => {
      this.checkInPly()
    }).bind(this))
  },
  beforeDestroy() {
    clearInterval(this.pendingTimerId)
  }
}



// WEBPACK FOOTER //
// ./resources/wob/vue/mixins/allBet.js